import { IconButton } from '@material-ui/core'
import Typography from '@material-ui/core/Typography/Typography'
import DeleteIcon from '@material-ui/icons/Delete'
import { memo } from 'react'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { ROLE } from '../../staticRoleManagement/types'
import useStyles from './styles/index'

interface SectionTitleProps {
  title: string
  marginBottom?: boolean
  deleteIcon?: boolean
  onClickOnDeleteIcon?: () => void
  disabled?: boolean
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  marginBottom,
  deleteIcon,
  onClickOnDeleteIcon,
  disabled
}) => {
  const classes = useStyles()

  const isRoleAdmin = getRoleFromStorage() === ROLE.ADMIN

  return (
    <div className={classes.root}>
      <Typography
        variant="h2"
        className={[
          classes.sectionTitle,
          marginBottom ? classes.marginBottom : ''
        ].join(' ')}>
        {getTranslate(title)}
      </Typography>
      {isRoleAdmin && deleteIcon && (
        <IconButton
          className={classes.deleteIcon}
          disabled={disabled}
          onClick={() => {
            onClickOnDeleteIcon?.()
          }}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  )
}
export default memo(SectionTitle)
